exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main{min-height:0;position:relative;overflow:hidden}.main-container{margin-left:50px!important;width:calc(100% - 50px)}.appFooter{font-size:12px;color:#bec9d2;line-height:20px;text-align:center}.iframe{height:calc(100vh - 50px);width:100%}", ""]);

// exports
